import { AxiosInstance } from "axios";
import {
  SupplyChainCountry,
  SupplyChainLanguage,
  SupplyChainParentalAdvisory,
  SupplyChainPrimaryGenre,
  SupplyChainProductType,
} from "./supplyChainModels";
import queryString from "query-string";
import { SUPPLY_CHAIN_DASHBOARD_OPTIONS } from "../../store/utils/routes";

export interface SupplyChainDashboardOptions {
  genres: SupplyChainPrimaryGenre[];
  languages: SupplyChainLanguage[];
  countries: SupplyChainCountry[];
  product_types: SupplyChainProductType[];
  parental_advisories: SupplyChainParentalAdvisory[];
}

// Required to retrieve correct format for options.
const params = {
  genres_fields: "name,parent,children,main",
  retailers_fields:
    "name,display_name,image,notes,status,website,xml_version,uuid,options_attributes,dates,syndication_statuses,credentials",
  product_types_fields: "main,name",
  main_product_types_fields: "main,name",
  tooltips_fields: "content,label,type",
};

const scDashBoardOptionsQueryParams = `?${queryString.stringify(params)}`;

export const getSupplyChainDashboardOptions = async (
  axiosInstance: AxiosInstance,
): Promise<SupplyChainDashboardOptions> => {
  const res = await axiosInstance.get(
    SUPPLY_CHAIN_DASHBOARD_OPTIONS + scDashBoardOptionsQueryParams,
  );
  return res.data.payload;
};
